<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const emit = defineEmits(['confirmed']);

const { t } = useI18n();
const dialogRef = ref(null);
const reason = ref('');

const isValid = computed(() => reason.value.trim().length > 0);

const open = () => {
  reason.value = '';
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const handleConfirm = () => {
  if (!isValid.value) return;
  emit('confirmed', reason.value.trim());
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('SALES.CANCEL.TITLE')"
    :confirm-button-label="t('SALES.CANCEL.CONFIRM')"
    :cancel-button-label="t('SALES.CANCEL.DISMISS')"
    confirm-button-color="ruby"
    :disable-confirm-button="!isValid"
    @confirm="handleConfirm"
  >
    <div class="flex flex-col gap-3 pt-2">
      <p class="text-sm text-n-slate-11">{{ t('SALES.CANCEL.DESCRIPTION') }}</p>
      <Input
        v-model="reason"
        :label="t('SALES.CANCEL.REASON_LABEL')"
        :placeholder="t('SALES.CANCEL.REASON_PLACEHOLDER')"
        type="text"
      />
    </div>
  </Dialog>
</template>
